export default {"src":"/_next/static/media/patio.15bc4d91.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};